// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/calculator.js';

import { paths } from '../generated/calculator';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('calculator', Original, paths);
